import { render, staticRenderFns } from "./PaymentSuccess.vue?vue&type=template&id=1ca950b4&scoped=true&"
import script from "./PaymentSuccess.vue?vue&type=script&lang=js&"
export * from "./PaymentSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca950b4",
  null
  
)

export default component.exports